import { jsx } from 'react/jsx-runtime';
import { useRef, useEffect, useState } from 'react';
import { getTzEndOfDay, getNow, getDateUtilsConfig, formatDate, getTzStartOfDay } from '@ninja/utilities';
import { Popover } from './Popover2.js';
import { TextLink } from './TextLink2.js';
import styles from './DatePicker4.js';
import { useCalendarViewContext } from './components10.js';
import { TimeView } from './components18.js';

const IntervalTimeFooter = ({ label, fieldKey, }) => {
    var _a, _b, _c;
    const toTimeHistory = useRef();
    const { updateViewState, viewState: { tzDate, currentCalendar, intervalStartDate, intervalEndDate }, } = useCalendarViewContext();
    const currentValue = (_c = (fieldKey === 'intervalEndDate'
        ? (_a = intervalEndDate !== null && intervalEndDate !== void 0 ? intervalEndDate : toTimeHistory === null || toTimeHistory === void 0 ? void 0 : toTimeHistory.current) !== null && _a !== void 0 ? _a : getTzEndOfDay((_b = intervalEndDate !== null && intervalEndDate !== void 0 ? intervalEndDate : intervalStartDate) !== null && _b !== void 0 ? _b : getNow())
        : intervalStartDate)) !== null && _c !== void 0 ? _c : tzDate;
    useEffect(() => {
        if (intervalEndDate)
            toTimeHistory.current = intervalEndDate;
    }, [intervalEndDate]);
    const { timeFormat } = getDateUtilsConfig();
    const format = timeFormat === '12hr' ? 'hh:mm aa' : 'HH:mm';
    const [isOpen, setIsOpen] = useState(false);
    const handleValueChange = (val) => {
        if (fieldKey == 'intervalStartDate') {
            updateViewState({ intervalStartDate: val });
        }
        else {
            if (!intervalStartDate)
                updateViewState({ intervalStartDate: getTzStartOfDay(val), intervalEndDate: val });
            else
                updateViewState({ intervalEndDate: val });
        }
        setIsOpen(false);
    };
    return (jsx("div", { className: styles.viewIntervalTimeFooter, children: jsx(Popover, { isOpen: isOpen, content: jsx("div", { className: styles.intervalTimePickerContainer, children: jsx(TimeView, { hideButtons: true, onValueChange: handleValueChange, currentSelectedDate: currentValue !== null && currentValue !== void 0 ? currentValue : toTimeHistory }) }), popoverVariant: "light", persistOnClick: true, onIsOpenChange: setIsOpen, className: "mt-20", children: jsx("div", { className: "flex px-4 py-2 w-full rounded-md hover:bg-gray-200", children: jsx(TextLink, { text: `${label}
					${formatDate(currentValue !== null && currentValue !== void 0 ? currentValue : toTimeHistory, {
                        dateFormat: format,
                        calendar: currentCalendar,
                    })}`, onClick: () => {
                        setIsOpen(true);
                    } }) }) }) }));
};

export { IntervalTimeFooter };
